import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen, AlertTriangle, CheckCircle, ShieldAlert, Info } from 'lucide-react';

const Education = () => {
  const guides = [
    {
      title: "Recognizing Clickbait",
      icon: <AlertTriangle className="w-8 h-8 text-yellow-500" />,
      content: "Headlines that use exaggerated language or emotional triggers (e.g., 'You Won't Believe This!') are often misleading. Always read beyond the headline."
    },
    {
      title: "Checking the Source",
      icon: <Info className="w-8 h-8 text-blue-500" />,
      content: "Is the website reputable? Check the 'About Us' section. Look for established news organizations rather than obscure blogs with no clear authorship."
    },
    {
      title: "Verifying Images",
      icon: <ShieldAlert className="w-8 h-8 text-red-500" />,
      content: "Deepfakes and manipulated images are common. Look for inconsistencies in lighting, shadows, and hands. Use reverse image search tools."
    },
    {
      title: "Cross-Reference",
      icon: <CheckCircle className="w-8 h-8 text-green-500" />,
      content: "If a story is true, multiple reliable outlets will report on it. If only one random source is reporting a major event, be skeptical."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 font-sans p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8 flex items-center justify-between">
            <Link to="/" className="inline-flex items-center text-gray-500 hover:text-primary transition-colors font-medium text-sm">
                <ArrowLeft className="w-4 h-4 mr-2" /> Back to Home
            </Link>
            <span className="font-heading font-bold text-lg text-primary tracking-tight">Hoax Education</span>
        </div>

        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
        >
            <BookOpen className="w-16 h-16 text-primary mx-auto mb-4" />
            <h1 className="text-4xl font-heading font-bold mb-4">How to Spot Misinformation</h1>
            <p className="text-gray-500 dark:text-gray-400 text-lg">Essential skills for the digital age.</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {guides.map((guide, idx) => (
                <motion.div 
                    key={idx}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.1 }}
                    className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700"
                >
                    <div className="mb-4">{guide.icon}</div>
                    <h3 className="text-xl font-bold mb-2">{guide.title}</h3>
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{guide.content}</p>
                </motion.div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Education;
